// setUsingGameId.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set the currently active game ID
 * @kind action
 * @param {object} params - parameters.
 * @param {import('../resource/gameConstants').Game} params.gameId - The game ID to set as active.
 * @return {Promise<Object>} Dispatched action object
 */
const setUsingGameId =
  ({ gameId } = {}) =>
  async dispatch => {
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['game'],
        data: {
          usingGameId: gameId,
        },
      },
    });
  };

export default setUsingGameId;
